<template lang="html">
  <div class="row">
    <div class="col col-lg-8">
      <h5>{{graphTitle}}</h5>
      <div class="spacer"></div>
      <slot></slot>
    </div>

    <div class="col col-lg-4">
      <h5>Time period and filters</h5>
      <div class="spacer"></div>

      <!-- Sélection de la période de temps -->
      <div class="form-group">
        <label>Time period :</label>
        <b-form-select class="custom-select" required
          v-model="sPeriod"
          @change="$emit('fetch-periode',sPeriod)"
          :options="periodOptions">
        </b-form-select>
      </div>
      <div class="spacer"></div>

      <!-- Filtre par IBAN -->
      <b-form-group label="Filter by IBAN :">
        <b-form-checkbox-group
          v-model="sIbans"
          :options="ibanOptions">
        </b-form-checkbox-group>
      </b-form-group>
      <div class="spacer"></div>

      <!-- Filtre par Contact -->
      <b-form-group label="Filter by contact :">
        <b-form-checkbox-group
          v-model="sContacts"
          :options="contactOptions">
        </b-form-checkbox-group>
      </b-form-group>

      <div class="spacer"></div>

      <b-button @click="$emit('filter-graph',{ibans:sIbans, contacts:sContacts})">Filter</b-button>
      <b-button @click="clearFilter()">Clear Filter</b-button>

      <div class="spacer"></div>

      <b-form-group label="Displayed Data :" v-if="trueValueLabel && falseValueLabel">
        <!-- <b-form-radio-group
          v-model="showing"
          :options="showOptions"
          plain
          name="plain-inline"
        ></b-form-radio-group> -->
        <b-form-radio-group>
          <b-form-radio
          v-model="showing"
          v-for="option in showOptions"
          :value="option.value"
          :key="option.value"
        >{{option.text}}</b-form-radio>
      </b-form-radio-group>
    </b-form-group>

    </div>
  </div>
</template>

<script>
import { capitalizeFirstLetter } from '@/helpers/format.js'

export default {
  props: ['graphTitle', 'periodes', 'ibans', 'contacts', 'value', 'trueValueLabel', 'falseValueLabel'], // value for v-model
  data () {
    return {
      periodOptions: [],
      sPeriod: 'month',
      ibanOptions: [],
      sIbans: [],
      contactOptions: [],
      sContacts: [],
      showOptions: []
    }
  },
  created () {
    this.periodOptions = this.periodes.map(entry => ({value: entry, text: capitalizeFirstLetter(entry)}))
    this.ibanOptions = this.ibans.map(entry => ({value: entry.iban, text: entry.name}))
    this.contactOptions = this.contacts.map(entry => ({value: entry.id, text: entry.alias}))
    this.showOptions = [{text: this.trueValueLabel, value: true}, {text: this.falseValueLabel, value: false}]
  },
  methods: {
    clearFilter () {
      this.sIbans = []
      this.sContacts = []
      this.$emit('clear-filter')
    },
    capitalize (word) {
      return capitalizeFirstLetter(word)
    }
  },
  computed: {
    // Pour le v-model
    showing: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style lang="css" scoped>
.spacer {
  margin-top: 40px;
  margin-bottom: 40px;
}
*:focus{ outline: none; } /* Enlever le border noir horrible sous Chrome (default border color for focused form elements) */
</style>



// WEBPACK FOOTER //
// GraphPanel.vue?3317252c